import { GridColumns } from '@wcg/frontend-framework';

export function applyLinkColumnStyles(columns: GridColumns): GridColumns {
  const result: GridColumns = { ...columns };
  Object.keys(result).forEach((key) => {
    const col = result[key] as GridColumns[string] & {
      component_type?: string;
    };
    const type = col.componentType ?? col.component_type;
    if (type === 'link') {
      result[key] = {
        ...col,
        hyperLinkClass: 'link-text underline text-[1.4rem] link-wrap',
      };
    }
  });
  return result;
}
